import component, { getRadioStyle } from './CardImageMobile';

export { getRadioStyle };
export default component;
